import React from "react";
import {Card, Typography, Tag, Alert} from "antd";
import {FilterOutlined, PlusOutlined} from "@ant-design/icons";

const {Paragraph, Text} = Typography;

const TagsInfoCard = () => {
    return (
        <Alert
            showIcon={true}
            style={{marginBottom: 16}}
            message={<div>
                <Text strong>Sildid</Text> aitavad sul kiiresti filtreerida ja
                organiseerida <Text underline>retsepte</Text> ja{" "}
                <Text underline>toiduaineid</Text>. Siltide abil saad grupeerida
                kirjeid kategooriatesse.
            </div>}
        >
        </Alert>
    );
};

export default TagsInfoCard;
